export default "__VITE_ASSET__DfZoxMtj__"